<!--
 * @Description: 
 * @Autor: tanglitong
 * @Date: 2019-11-11 18:11:37
 * @LastEditors: tanglitong
 * @LastEditTime: 2022-06-14 11:46:05
-->
<template>
  <div>
    <!-- :src="`${handoutUrl}#toolbar=0`" -->
    <iframe :src="`${handoutUrl}#toolbar=0`"
            style="position:absolute; left:0; top:0; height:100%; width:100%; border:0px;">
    </iframe>
    <!-- <DialogScoreBuyShop v-model="scoreBuyShopDialogShow" :trainingId="trainingId" :typed="showorNotParams"
                        @showorNot="showorNot"/>
    <DialogScoreBuyShopCallback/> -->
  </div>
</template>

<script>
import { bangDingCard, getCourseWareByCourse, getTrainingById, saveWatchRecords, syncHandoutStatus } from '../api/api_new.js'
//import DialogScoreBuyShop from '../components/DialogScoreBuyShop'
//import DialogScoreBuyShopCallback from '../components/DialogScoreBuyShopCallback'
import { mapGetters } from 'vuex'
import { CloseWebPage } from '../utils/global-methods'
import { VerifyDeviceBinding } from '../utils/fingerprint'
import moment from 'moment'


export default {
  components: {
    //DialogScoreBuyShop,
   // DialogScoreBuyShopCallback
  },
  data() {
    return {
      handoutUrl: '',
      scoreBuyShopDialogShow: false,
      trainingId: this.$route.query.tId,
      showorNotParams: '',
      retry: 1,//可重试发送次数
      startime:0,
    }
  },
   computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted() {
    // this.saveWatchRecords()
    this.startime= moment().format('YYYY-MM-DD HH:mm:ss')
    this.getTrainingById()
    bangDingCard(this.$route.query.tId, this.$route.query.uId).then(res => {
      if (res.data.code == 0) {
        if (res.data.traning.creditBingdingTerm == 1 && !res.data.traning.isBandCard) {
          this.scoreBuyShopDialogShow = true
          this.showorNotParams = '暂未绑卡-链接查看'
        }
      }
    })
    getCourseWareByCourse({//获得课件，类型为讲义type=2
      userId: this.$route.query.uId,
      trainingId: this.$route.query.tId,
      projId: this.$route.query.pId,
      courseId: this.$route.query.cId,
      type: 2//讲义
    }).then((response) => {
      document.title = response.data.data.courseName
      let handoutInfo = response.data.data.handoutInfo
      this.handoutUrl = handoutInfo.url
      if ((!handoutInfo.done) && handoutInfo.lectureMinute) {
        setTimeout(() => {
          const endtime= moment().format('YYYY-MM-DD HH:mm:ss')
          const timeDiff=moment(endtime).diff(moment(this.startime), 'seconds')
          syncHandoutStatus({//同步讲义状态
            trainingId: this.$route.query.tId,
            projId: this.$route.query.pId,
            courseId: this.$route.query.cId,
            uuid:this.userInfo.uuid,
            time: timeDiff
          }).then((response) => {
            const { code } = response.data
            if (code === 1) {
              this.$message.error('同步异常')
            } else if (code ===-1) {
              this.$confirm('培训已结束!', '提示', {
                confirmButtonText: '确定',
                showClose: false,
                showCancelButton: false,
                type: 'warning'
              }).then(() => {
                CloseWebPage()
              }).catch(() => {
              })
            } else if (code === 0) {
              //
            }
            // if (!response.data) {
            //   this.$message.error('同步异常')
            // }
          })
        }, handoutInfo.lectureMinute * 60 * 1000)
        //handoutInfo.lectureMinute * 60 * 1000
      }

    }
    )
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    /**
     * @description: 上传学习记录
     */
    saveWatchRecords() {
      // const uuid = this.$route.query.uuid
      // if (!uuid) return
      // const storageuuid = sessionStorage.getItem(uuid)
      // if (!storageuuid) {
      const params = {
        // batchId: uuid,
        userId: this.userInfo.id,
        trainingId: this.$route.query.tId,
        projId: this.$route.query.pId,
        courseId: this.$route.query.cId,
        type: 1
      }
      saveWatchRecords(params).then(res => {
        const data = res.data
        if (data.code !== 0) {
          this.$alert(data.msg, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false,
            callback: action => {
              CloseWebPage()
            }
          })

        }
        // sessionStorage.setItem(uuid, uuid)
      }).catch(() => {
        if (this.retry > 0) {
          this.retry--
          setTimeout(() => {
            this.saveWatchRecords()
          }, 1000)
        }
      })
      // }
    },
    /**
     * @description: 查询培训班详情
     */
    getTrainingById() {
      const params = {
        id: this.$route.query.tId,
        userId: this.$route.query.uId
      }
      getTrainingById(params).then(res => {
        const training = res.data.data.training
        if (training.limitSingleDeviceLearning === 1) {
          // VerifyDeviceBinding(this.userInfo.id)
          setTimeout(()=>{
            VerifyDeviceBinding(this.$route.query.tId)
          },2000)
          
        }
      })
    },
    showorNot(val) {
      if (val == '暂未绑卡-链接查看') {

      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Handout.vue